import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../pages/Home.vue';
import Settings from '../pages/Settings.vue';
// eslint-disable-next-line
import store from '../store';

Vue.use(VueRouter);

// const formatAsCurrency = (value) => {
//   if (!value) {
//     return value;
//   }
//   return value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
// };


const routes = [
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
  },
  {
    path: '/templates',
    name: 'templates',
    component: Home,
  },
  {
    path: '/',
    name: 'login',
    // eslint-disable-next-line
    component: () => {
      return window.template ? import('../pages/Template/Template.vue') : import('../pages/Login.vue');
    },
  },
  {
    path: '/template/new/',
    name: 'new',
    component: () => import('../pages/Template/Template.vue'),
  },
  {
    path: '/template/:id/',
    name: 'template',
    component: () => import('../pages/Template/Template.vue'),
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../pages/Feedback.vue'),
  },
  {
    path: '/passwordReset/',
    name: 'updatePassword',
    component: () => import('../pages/Login.vue'),
    props: { updatePasswordNow: true },
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});

// router.afterEach((to) => {
//   if (to.name === 'templates') {
//     // refresh user templates
//     store.dispatch('getUserData');
//   }
// });

router.afterEach((to) => {
  // store.dispatch('log', { requestedPath: to.path });
  const currentMenuItem = Object.keys(store.state.menuItems).find((key) => key === to.name);
  if (currentMenuItem) {
    const pageTitle = currentMenuItem.title;
    store.commit('updatePageTitle', pageTitle);
  }
  // reset store values
  store.commit('updateState', {
    path: 'dialogs.endOfWizardDialogVisible',
    value: false,
  });
  // scroll to top
  window.scroll(0, 0);
});


export default router;
